import React from 'react';

interface CityPopularSearchesProps {
  beds: number[];
  amenities: string[];
  /** When provided, clicking a link applies filters in-page instead of navigating. */
  onFilterApply?: (filters: Record<string, string>) => void;
}

const RENT_TIERS = [600, 700, 800, 900, 1000, 1500, 2000];
const DEFAULT_BEDS = [1, 2, 3];

export function CityPopularSearches({ beds, amenities, onFilterApply }: CityPopularSearchesProps) {
  const sortedBeds = [...new Set(beds.length > 0 ? beds : DEFAULT_BEDS)].sort((a, b) => a - b);
  const sortedAmenities = [...new Set(amenities)].sort((a, b) => a.localeCompare(b)).slice(0, 8);

  return (
    <div className="case-market-links">
      <h2>Try These Popular Searches</h2>
      <div className="case-market-links-grid">
        <div className="case-market-links-group">
          <div>
            <h3>Apartments by Bedrooms</h3>
            <ul>
              {sortedBeds.map(b => (
                <li key={b}><a href={`?beds=${b}`} onClick={onFilterApply ? (e) => { e.preventDefault(); onFilterApply({ beds: String(b) }); } : undefined}>{b} Bedroom Rentals</a></li>
              ))}
            </ul>
          </div>
          <div style={{ marginTop: '25px' }}>
            <h3>Apartments by Rent</h3>
            <ul>
              {RENT_TIERS.map(p => (
                <li key={p}>
                  <a href={`?max-price=${p}`} onClick={onFilterApply ? (e) => { e.preventDefault(); onFilterApply({ maxPrice: String(p) }); } : undefined}>
                    Apartments Under ${p.toLocaleString()}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Amenity search hidden — amenity data is not standardized and no filter exists yet.
           Uncomment when amenity filtering is implemented.
        {sortedAmenities.length > 0 && (
          <div className="case-market-links-group">
            <h3>Apartments by Amenity</h3>
            <ul>
              {sortedAmenities.map(a => (
                <li key={a}>
                  <a href={`?amenities=${a.replace(/ /g, '+').replace(/&/g, '%26').replace(/\//g, '%2F')}`}>
                    Apartments with {a}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
        */}
      </div>
    </div>
  );
}

export default CityPopularSearches;
